import styled from 'styled-components';
import BookingProgressSvg from '../../assets/mytrips/booking-progress.svg';

const BookingProgressIcon = styled(BookingProgressSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4.8rem'};
  height: ${props => props.height || '4.8rem'};
  margin: ${props => props.margin};
`;

export default BookingProgressIcon;
